import React, { useContext, useRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import classNames from 'classnames';
import { AppContext } from '../../context/App';

const StyledContainer = styled.main`
	margin: 0 auto;

	transition: margin 0.25s, width 0.25s ease;
	overflow-x: auto;
	overflow-y: auto;
	position: relative;
	height: auto;
	z-index: 5;
	&.full {
		display: flex;
		justify-content: center;
		flex-direction: column;
		min-height: 100vh;
		padding-bottom: 15px;
		margin: 0;
	}
`;

const Container = ({ children, className, ...props }) => {
	const ref = useRef();

	const { fullPage } = useContext(AppContext);
	const cssClasses = classNames({ className, full: fullPage });

	return (
		<StyledContainer className={cssClasses} {...props} ref={ref}>
			{children}
		</StyledContainer>
	);
};

Container.propTypes = {
	children: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.node),
		PropTypes.node,
	]).isRequired,
	className: PropTypes.string,
};

Container.defaultProps = {
	className: ' ',
};

export default Container;
